import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  SMART_DROPDOWN_FILE_UPLOAD,
  SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES,
} from "./actionTypes"

import {
  fileUploadSuccess,
  fileUploadError,
} from "./actions"

import {
  apiPostFileUpload,
  apiPostInboxNotificationUploadFiles,
} from "../../../api/calls/smartDropzone"

function* fileUpload({payload: data}) {
  try {
    const response = yield call(apiPostFileUpload, data)
    yield put(fileUploadSuccess(response))
    data.uploadSuccess(response)
  } catch (error) {
    yield put(fileUploadError(error))
  }
}

function* notificationUploadFiles({payload: data}) {
  try {
    yield call(apiPostInboxNotificationUploadFiles, data)
  } catch (error) {
  }
}

export function* watchFileUpload() {
  yield takeEvery(SMART_DROPDOWN_FILE_UPLOAD, fileUpload);
}

export function* watchNotificationUploadFiles() {
  yield takeEvery(SMART_DROPDOWN_NOTIFICATION_UPLOAD_FILES, notificationUploadFiles);
}

function* smartDropzoneSaga() {
  yield all([
    fork(watchFileUpload),
    fork(watchNotificationUploadFiles),
  ]);
}

export default smartDropzoneSaga
